import { RayCodeConstant } from '../actions/constants/RayCodeConstant';

const initialState = {
	items : [],
	item : {},
    isLoading : false,
	totalproductcount: 0,
};

export const RayCodeReducer = (state = initialState, action) => {
	switch (action.type) {
		case RayCodeConstant.GET_RAYCODELIST: {
			// BUG-157: SSoT 정규화 — items 를 항상 배열로 보장해 소비처(DeepSearch/AdminTopMenu/HomePage 등 clist?.filter) 크래시 클래스(#28)를 원천 차단.
			// 비배열 유입은 데이터 이상 신호이므로 silent-drop 대신 warn 으로 관측 가능하게 남긴다.
			if (!Array.isArray(action.items)) {
				console.warn('[RayCodeReducer] GET_RAYCODELIST items is not an array; coerced to []', { received: typeof action.items });
				return { ...state, items: [] };
			}
			return { ...state, items: [...action.items] };
		}
		case RayCodeConstant.UPDATE_RAYCODE:
		case RayCodeConstant.GET_RAYCODE:
			return {
				...state,
				items: state.items.map((u) => (u._id == action.item._id ? action.item : u)),
				item: action.item,
			};
		case RayCodeConstant.CREATE_RAYCODE:
			return {
				...state,
				items : [...state.items, action.item],
				item: action.item,
			};
		case RayCodeConstant.DELETE_RAYCODE:
			return { ...state, items: state.items.filter((u) => u._id !== action._id), item : {}};
		case RayCodeConstant.ADDUPDATE:
			return { ...state, item: action.item };
        case RayCodeConstant.LOADING:
            return {...state, isLoading : true}
        case RayCodeConstant.LOADED:
            return {...state, isLoading : false}
		default:
			return state;
	}
};
